import { render } from "./message-push-modal.vue?vue&type=template&id=3c372ee0&scoped=true&ts=true"
import script from "./message-push-modal.vue?vue&type=script&lang=ts"
export * from "./message-push-modal.vue?vue&type=script&lang=ts"

import "./message-push-modal.vue?vue&type=style&index=0&id=3c372ee0&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c372ee0"]])

export default __exports__